<button [style.direction]="dir" [dir]="dir"  class="btn" #trigger [cdkMenuTriggerFor]="menu" [disabled]="isDisabled()">
  <ng-content select="[trigger]"></ng-content>
  @if (iTrigger()?.isOpen() && disableCaret()) {
    <i [@fadeUpDown]
    class="fa-thin text-xl fa-caret-up text-zen-primaryLight text-opacity-40"></i>
  }

</button>
<ng-template #menu>
  <div [style.direction]="dir" [dir]="dir" (click)="handleClick($event, trigger)" [@fadeUpDown]
    class="inline-flex flex-col items-stretch bg-white text-sm text-zen-primaryLight border border-zen-primaryLight border-opacity-10 rounded p-1 mt-2"
    cdkMenu>
    <ng-content></ng-content>
  </div>
</ng-template>